
import './App.css';
import LoginView from './LoginView';
import MainView from './view/Main';
import PersonInfo from './view/infoViews/personInfo';
import AddressInfo from './view/infoViews/addressInfo';
import AutoInfo from './view/infoViews/autoInfo';
import CompanyInfo from './view/infoViews/companyInfo';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ContactInfo from './view/infoViews/contactInfo';
import DocumentInfo from './view/infoViews/documentInfo';
import GunInfo from './view/infoViews/gunInfo';
import ProceedingsInfo from './view/infoViews/proceedingsInfo';
import OPMInfo from './view/infoViews/opmInfo';
import TraitorInfo from './view/infoViews/traitorInfo';
import KanInfo from './view/infoViews/kanInfo';
import BSInfo from './view/infoViews/bsInfo';
import PersonEdit from './view/editViews/personEdit';
import AddressEdit from './view/editViews/addressEdit';
import AutoEdit from './view/editViews/autoEdit';
import CompanyEdit from './view/editViews/companyEdit';
import ContactEdit from './view/editViews/contactEdit';
import OPMEdit from './view/editViews/opmEdit';
import ProceedingsEdit from './view/editViews/proceedingsEdit';
import DocumentEdit from './view/editViews/documentEdit';
import GunEdit from './view/editViews/gunEdit';
import TraitorEdit from './view/editViews/traitorEdit';
import KanEdit from './view/editViews/kanEdit';
import BSEdit from './view/editViews/bsEdit';
import MapsInfo from './view/infoViews/mapsInfo';

function App() {
  return (
    
    <Router>
      <Routes>
        <Route path="/login" element={<LoginView />} />
        <Route path="/main" element={<MainView />} />
        <Route path='/person' element={<PersonInfo/>} />
        <Route path='/address' element={<AddressInfo/>} />
        <Route path='/auto' element={<AutoInfo/>} />
        <Route path='/company' element={<CompanyInfo/>} />
        <Route path='/contact' element={<ContactInfo/>} />
        <Route path='/document' element={<DocumentInfo/>} />
        <Route path='/gun' element={<GunInfo/>} />
        <Route path='/proceedings' element={<ProceedingsInfo/>} />
        <Route path='/opm' element={<OPMInfo/>} />
        <Route path='/traitor' element={<TraitorInfo/>} />
        <Route path='/kan' element={<KanInfo/>} />
        <Route path='/bs' element={<BSInfo/>} />
        <Route path='/edit/person' element={<PersonEdit/>} />
        <Route path='/edit/address' element={<AddressEdit/>} />
        <Route path='/edit/auto' element={<AutoEdit/>} />
        <Route path='/edit/company' element={<CompanyEdit/>} />
        <Route path='/edit/contact' element={<ContactEdit/>} />
        <Route path='/edit/opm' element={<OPMEdit/>} />
        <Route path='/edit/proceedings' element={<ProceedingsEdit/>} />
        <Route path='/edit/document' element={<DocumentEdit/>} />
        <Route path='/edit/gun' element={<GunEdit/>} />
        <Route path='/edit/traitor' element={<TraitorEdit/>} />
        <Route path='/edit/kan' element={<KanEdit/>} />
        <Route path='/edit/bs' element={<BSEdit/>} />
        <Route path='/maps' element={<MapsInfo/>} />
        <Route
              path="*"
              element={<Navigate to="/login" replace />}
          />
      </Routes>
    </Router>
  );
}

export default App;
